$('.participation__options__item__caption').on('click', function () {
    const $button = $(this);
    const $item = $(this).closest('.participation__options__item');
    const $content = $item.find('.participation__options__item__content');
    $('.participation__options__item__caption').not($button).removeClass('active');
    $('.participation__options__item__content').not($content).slideUp();
    $button.toggleClass('active');
    $content.slideToggle();
});